// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1945":"3e706ae71c4518ca","6901":"56fb8570f114a391"}[chunkId] + ".css";
};